import { type Validator } from "../../base_classes/dto_validator.d";

const validators: Validator[] = [];

export default validators;
